import { render, staticRenderFns } from "./legalPerson.vue?vue&type=template&id=6d6b5788&scoped=true&"
import script from "./legalPerson.vue?vue&type=script&lang=js&"
export * from "./legalPerson.vue?vue&type=script&lang=js&"
import style0 from "./legalPerson.vue?vue&type=style&index=0&id=6d6b5788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6b5788",
  null
  
)

export default component.exports